import React, {useState,useEffect} from 'react'; // useeffect something at once as mount READ useEffect DOC
import alanBtn from '@alan-ai/alan-sdk-web'; //alanBtn is alan botton
import WordsToNumbers from 'words-to-numbers';


import './flicker.css';
import NewsCards from './components/NewsCards/NewsCards';
import useStyles from './styles.js'


const alanKey='159c820f59f9b1d3bb3a373d6e5bd96e2e956eca572e1d8b807a3e2338fdd0dc/stage'; //get this from alan.app 

const App= () =>{
	const [newsArticles,setNewsArticles]=useState([]);
	
	const [activeArticle,setActiveArticle]=useState(-1);
	const classes=useStyles(); 



    useEffect( ()=> {      //basic skelton useeffect(()=> {},[])

    	alanBtn({
    		 key: alanKey,
    		 onCommand: ({command,articles,number}) => {
    		 	if(command === 'newHeadlines'){
    		 		setNewsArticles(articles);
    		 		setActiveArticle(-1);
    		 	} else if(command==='highlight'){
    		 		setActiveArticle((prevActiveArticle)=> prevActiveArticle + 1);
    		 	}
    		 	else if(command==='open'){
    		 		//fuzzy ensures for=four=4 by sppech to text engine
    		 		const parsedNumber=number.length>2 ? WordsToNumbers(number,{fuzzy:true}):number;
    		 		const article=articles[parsedNumber-1];

    		 		if (parsedNumber > 20) {
          			  alanBtn().playText('Please try that again...');
       			    } else if (article) {
         			   window.open(article.url, '_blank');
         			   alanBtn().playText('Opening...');
         			} else {
          			  alanBtn().playText('Please try that again...');
         			 }
    		 	}
    		 }


    	})
    },[])

	return (
		<div>
		     <div>
		     	<div style={{margin:"5% 0% 4% 17%"}}>
		     	
	                <span id="G">Voice-controlled</span>
	                <span id="I"> AI</span>
	                <span id="G"> News </span>
	                <span id="H">application</span>
	                
                </div>
		     </div>
		     <NewsCards articles={newsArticles} activeArticle={activeArticle} />

		     <div style={{margin:"6%"}}>
		     	
	                <span id="J">  Developed by :</span>
	                <span id="V"> Viv</span>
	                <span id="V">ek </span>
	                <span id="V">Sah</span>
	                <span id="V">ani</span>
                    <span id="J"> (vivek2vks@gmail.com)</span></div>


		</div>

		);
}
export default App;